export default "__VITE_ASSET__Ci5LcBmY__"